module.exports = __webpack_public_path__ + "img/33_49.9392a624.png";